<template>
  <div class="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
    </div>

    <div>
      <h3> AICOOL Offline Translation Paid Service Agreement</h3>
      <p class="pt8">Release Date: July 10, 2025</p>
      <p class="pt8">Effective Date: July 10, 2025</p>
      <div class="fw700 pt8">
        Welcome to  AICOOL’s Offline Translation Paid Service. Please read, understand, and comply with the following agreement carefully.
      </div>

      <div class="section-title">1. Service Description</div>
      <p class="p8">1.After purchase, users may enjoy offline translation services, including but not limited to:</p>
      <p class="pt5">
        o Offline translation functionality (supports 10 language packs: Chinese, English, German, Japanese, Korean, Hindi, Thai, Spanish, French, and Russian. Specific languages are subject to in-app display).
      </p>
      <p class="pt5">o Ad-free experience and higher-priority server response.</p>

      <div class="section-title">2. Disclaimer</div>
      <p class="p8">1.Translation Accuracy:</p>
      <p class="pt5">
        o Translation results may be affected by environmental noise, recording devices, speech clarity, etc.100% accuracy is not guaranteed.
      </p>
      <p class="pt5">o Language expressions vary, and translations may not be unique.</p>
      <p class="pt5">o Occasional inaccuracies in certain phrases are normal and do not qualify for refunds.</p>
      <p class="p8">2.Offline Translation Limitations:</p>
      <p class="pt5">o Offline language packs require manual download and are only available for downloaded languages.</p>
      <p class="pt5">o Offline translation may not receive the same precision updates as online translation.</p>
      <div class="section-title">3. Purchase Terms</div>
      <p class="p8">1.Payment Methods: Completed via official app stores or designated payment channels.</p>
      <p class="pt5">2.Virtual Product Policy: No refunds or transfers after successful payment.</p>
      <p class="pt5">
        3.Validity Period: Offline translation grants permanent access, but rights are device-bound. Service must be repurchased if switching devices.
      </p>
      <div class="section-title">4. Account Responsibilities</div>
      <p class="p8">1.Purchases through unofficial channels are prohibited. Users bear all resulting losses.</p>
      <p class="pt5">2.Account sharing may lead to service termination without refund.</p>
      <p class="pt5">3.Breach of terms may result in service suspension without refund.</p>

      <div class="section-title">5. Service Modifications</div>
      <p class="p8">1.We reserve the right to adjust service content, pricing, or terms. Major changes will be notified in advance.</p>
      <p class="pt5">2.For service interruptions due to force majeure, reasonable compensation will be provided.</p>

      <div class="section-title">6. Privacy Policy</div>
      <p class="p8">1.Translated content will be encrypted per the Privacy Policy.</p>
      <p class="pt5">2.Users must ensure input complies with laws and regulations.</p>

      <div class="section-title">7. Dispute Resolution</div>
      <p class="p8">1.For disputes, contact customer service within 7 days of payment at: service@xuanjiai.cn.</p>
      <p class="pt5">2.Final interpretation rights belong to Shenzhen Xuanji AI Technology Co., Ltd.</p>
      

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: "cn",
      closeImage: require("@/assets/close.png"),
      width: "100%",
      height: "100vh",
      url: "https://www.xuanjiai.cn/app/terms.html",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "cn";
    if (this.lang === "cn") {
      this.url = "https://www.xuanjiai.cn/app/terms.html";
    } else {
      this.url = "https://www.xuanjiai.cn/app/terms_en.html";
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/OffLinePage",
      });
    },
  },
};
</script>

<style scoped>
.app {
  height: 100vh;
  text-align: left;
  overflow: auto;
  padding: 0px 16px;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.user-agreement {
  height: calc(100vh - 44px);
  border: none;
  overflow: hidden;
}
iframe {
  overflow: hidden;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
.p8 {
    padding: 8px 0px;
}
.pt8 {
  padding-top: 8px;
}
.fw700 {
  font-weight: 700;
}
.pt5 {
    padding-bottom:5px;
}
</style>